// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._qoZePxnE0jopL0G4jWC{flex-direction:column;gap:16px;margin-top:16px;display:flex}._qoZePxnE0jopL0G4jWC .GVye4BjyFVADTHKxpFs3{resize:none;min-height:62px;max-height:200px;padding-bottom:8px;font-size:13px;overflow-y:auto}.CddyZz58uBApmSTUXAw3{max-width:180px}.e7pL0O0d_UsVS88J5A2W{margin-bottom:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `_qoZePxnE0jopL0G4jWC`,
	"messageTextarea": `GVye4BjyFVADTHKxpFs3`,
	"daysWrap": `CddyZz58uBApmSTUXAw3`,
	"daysLabel": `e7pL0O0d_UsVS88J5A2W`
};
export default ___CSS_LOADER_EXPORT___;
